<section
  class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold" i18n="@@basicInformation">Offer Basic Information</h2>
  </div>

  <div></div>

  <div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-3">
    <!-- 01 -->
    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold uppercase" i18n="@@offerName">
        {{ isArabic() ? "اسم العرض" : "Offer Name" }}
      </span>
      <span class="valueColor">
        {{
          isArabic()
            ? offer()?.titleAr || offer()?.titleEn || "غير متوفر"
            : offer()?.titleEn || offer()?.titleAr || "Not Provided"
        }}
      </span>
    </div>

    <!-- 03 -->
    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold uppercase" i18n="@@status">status</span>
      <span class="valueColor">
        <span
          [ngClass]="getStatusClass(offer()?.status)"
          class="inline-flex min-w-[75px] items-center justify-center rounded-full px-2 py-1 text-[10px] font-bold">
          {{ isArabic() ? offer()?.status?.titleAr || "غير متوفر" : offer()?.status?.titleEn || "Not Provided" }}
        </span>
      </span>
    </div>
    <!-- 04 -->

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold uppercase">
        {{ isArabic() ? "تاريخ النهاية" : "End Date" }}
      </span>
      <span class="valueColor">
        {{ offer()?.endDate | dateTime }}
      </span>
    </div>

    <!-- 04 -->

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold uppercase">
        {{ isArabic() ? "تاريخ البداية" : "Start Date" }}
      </span>
      <span class="valueColor">
        {{ offer()?.startDate | dateTime }}
      </span>
    </div>
    <!-- 05 -->
    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold uppercase">
        {{ isArabic() ? "أنشئ بواسطة" : "Created By" }}
      </span>
      <span class="valueColor">
        {{ offer()?.createdBy?.fullName }}
      </span>
      <span class="valueColor">
        {{ offer()?.createdOn | date }}
      </span>
    </div>

    <!-- 06 -->
    @if (offer()?.lastModifiedBy) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold uppercase">
          {{ isArabic() ? "آخر تحديث في" : "Last Updated On" }}
        </span>
        <span class="valueColor">
          {{ offer()?.lastModifiedBy?.fullName }}
        </span>
        <span class="valueColor">
          {{ offer()?.lastModifiedOn | date }}
        </span>
      </div>
    }
    <div class="col-span-1 flex flex-col gap-1.5 border-t border-gray-50 pt-3 md:col-span-3">
      <span class="grayColor font-bold">
        {{ isArabic() ? "وصف العرض" : "Offer Description" }}
      </span>
      <p class="valueColor max-w-3xl text-[13px] leading-[1.5] font-medium">
        {{
          isArabic()
            ? offer()?.descriptionAr || offer()?.descriptionEn || "غير محدد"
            : offer()?.descriptionEn || offer()?.descriptionAr || "Not Set"
        }}
      </p>
    </div>
  </div>
</section>

<section
  class="animate-in fade-in slide-in-from-bottom-2 mt-6 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold" i18n="@@offerTypeDetails">Offer Type Details</h2>
  </div>

  <div></div>

  <div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-3">
    <!-- 01 -->

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="grayColor font-bold uppercase" i18n="@@offerType">
        {{ isArabic() ? "نوع العرض" : "Offer Type" }}
      </span>
      <span class="valueColor">
        {{
          isArabic()
            ? offer()?.offerType.titleAr || offer()?.offerType.titleEn || "غير متوفر"
            : offer()?.offerType.titleEn || offer()?.offerType.titleAr || "Not Provided"
        }}
      </span>
    </div>

    @if (+offer()?.offerType?.id === 1) {
      <!-- 03 -->
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold uppercase" i18n="@@discountType">Discount Type</span>
        <span class="valueColor">
          {{
            offer()?.discountType === "PERCENTAGE"
              ? isArabic()
                ? "نسبة مئوية"
                : "Percentage"
              : isArabic()
                ? "مبلغ ثابت"
                : "Fixed Amount"
          }}
        </span>
      </div>
      <!-- 04 -->

      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold uppercase" i18n="@@discountValue">Discount Value</span>
        <span class="valueColor text-lg font-bold">
          {{ offer()?.discountValue }}
        </span>
      </div>
    } @else {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold uppercase" i18n="@@buyQuantity">Buy Quantity (X)</span>
        <span class="valueColor">
          {{ offer()?.buyQuantity }}
        </span>
      </div>
      <!-- 04 -->

      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="grayColor font-bold uppercase" i18n="@@getQuantity">Get Free Quantity</span>
        <span class="valueColor">
          {{ offer()?.getQuantity }}
        </span>
      </div>
    }
  </div>
</section>
